// extracted by mini-css-extract-plugin
module.exports = {"container":"comment-moderation_container__2zmex","sidebar":"comment-moderation_sidebar__SDiIJ"};